import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ImagesPanel from "./ImagesPanel";
import ImageProperties from "./ImageProperties";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import GalleryPanel from "./GalleryPanel";
import {setBackgroundState} from "../../../store/reducers/modalToggler";
import {CustomTabPanel} from "../../../utils/utilityComponents";

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ImageTabs({setToggleSubMenu, stopEvents, initEvents}) {
    const [value, setValue] = useState(0);
    const {activeObject} = useSelector((state) => state.canvas);

    const dispatch = useDispatch()

    useEffect(() => {
        if(activeObject?.type === 'image' || activeObject?.type === 'group' || activeObject?.type === 'path'){
            setValue(0)
        }
    },[activeObject])

    const handleChange = (event, newValue) => {
        setValue(newValue);
        dispatch(setBackgroundState(false))
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs className='images-panel-tabs' sx={{ justifyContent: 'space-between' }} value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="Edit Image" {...a11yProps(0)} />
                    <Tab label="Images" {...a11yProps(1)} />
                    <Tab label="Gallery" {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                <ImageProperties setToggleSubMenu={setToggleSubMenu} stopEvents={stopEvents} initEvents={initEvents} setValue={setValue}/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                <ImagesPanel setToggleSubMenu={setToggleSubMenu}/>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                <GalleryPanel setToggleSubMenu={setToggleSubMenu}/>
            </CustomTabPanel>
        </Box>
    );
}
